import 'common/index';
import '../src/theme.scss'

if (!window.easyreviews) {

    var easyreviews = function () {

        var init = function init() {

            let easyreviewsElement = document.querySelectorAll('.js-easyreviews');

            initModal();

            initReviewRating();

            initInputFiles();

            // initLazyLoading();

            for (let i = 0; i < easyreviewsElement.length; i++) {

                // yandexParams
                let yandex = {
                    counter: easyreviewsElement[i].getAttribute('data-counter'),
                    submit: easyreviewsElement[i].getAttribute('data-submit'),
                    error: easyreviewsElement[i].getAttribute('data-error'),
                }

                // GoogleParams
                let google = {
                    submit: easyreviewsElement[i].getAttribute('data-gsubmit'),
                    submitAction: easyreviewsElement[i].getAttribute('data-gsubmitAction'),
                    error: easyreviewsElement[i].getAttribute('data-gerror'),
                    errorAction: easyreviewsElement[i].getAttribute('data-gerrorAction'),
                }

                // Modal
                let easyreviewsModal = easyreviewsElement[i].closest('.easyreviews-modal');

                // Form
                let easyreviewsForm = easyreviewsElement[i].querySelector('.js-easyreviews__form');
                let easyreviewsSubmit = easyreviewsElement[i].querySelector('.js-easyreviews__submit');
                let easyreviewsUrl = easyreviewsForm.getAttribute('action');

                // Phones
                let easyreviewsPhones = easyreviewsElement[i].querySelectorAll('.js-easyreviews__phone');

                easyreviewsPhones.forEach(function (element) {
                    initPhone(element);
                });

                easyreviewsSubmit.addEventListener('click', function (event) {

                    let checkValidityAttr = easyreviewsElement[i].getAttribute('data-checkValidity');
                    let checkValidity = (checkValidityAttr == null || checkValidityAttr == '') ? false : true;
                    let isValid = (checkValidity == true) ? easyreviewsForm.checkValidity() : true;


                    if (isValid) {

                        event.preventDefault();

                        let loader = document.createElement('div');
                        loader.classList.add('loading-overlay', 'loading-overlay--absolute');
                        loader.innerHTML = '<div class="loader"></div>';

                        easyreviewsElement[i].classList.add('is-loading');
                        easyreviewsElement[i].appendChild(loader);

                        let errorElement = easyreviewsElement[i].querySelectorAll('.is-error');

                        errorElement.forEach(function (element) {
                            element.classList.remove('is-error');
                            element.querySelector('.js-easyreviews__field-error').innerHTML = '';
                        });

                        let formData = new FormData(easyreviewsForm);
                        let file = easyreviewsForm.querySelector('file');

                        formData.append('file', file);

                        let xhr = new XMLHttpRequest();
                        xhr.responseType = 'json';

                        xhr.onreadystatechange = function () {
                            if (xhr.readyState == XMLHttpRequest.DONE) {

                                easyreviewsElement[i].classList.remove('is-loading');
                                easyreviewsElement[i].querySelector('.loading-overlay').remove();

                                if (xhr.status === 200) {

                                    if (xhr.response.data.status == 'error') {

                                        let errors = Object.keys(xhr.response.data.errors);
                                        if (errors.length > 0) {

                                            errors.forEach(function (element) {

                                                let errorField = easyreviewsElement[i].querySelector('.js-easyreviews__field--' + element);
                                                let errorElement = errorField.querySelector('.js-easyreviews__field-error');

                                                errorField.classList.add('is-error');
                                                errorElement.innerHTML = xhr.response.data.errors[element];

                                            });

                                            if (yandex.counter && yandex.error) {
                                                sendYandex(yandex.counter, yandex.error);
                                            }

                                            if (google.error && google.errorAction) {
                                                sendGoogle(google.error, google.errorAction);
                                            }

                                        }
                                    } else {
                                        let successMessage = easyreviewsElement[i].querySelector('.js-easyreviews__success');

                                        successMessage.classList.add('is-visible');
                                        easyreviewsForm.classList.add('is-hidden');

                                        if (easyreviewsModal != null) {
                                            let easyreviewsTitle = easyreviewsModal.querySelector('.js-easyreviews-title');
                                            let easyreviewsDescription = easyreviewsModal.querySelector('.js-easyreviews-description');

                                            if (easyreviewsTitle) {
                                                easyreviewsTitle.classList.add('is-hidden');
                                            }
                                            if (easyreviewsDescription) {
                                                easyreviewsDescription.classList.add('is-hidden');
                                            }
                                        }

                                        if (yandex.counter && yandex.submit) {
                                            sendYandex(yandex.counter, yandex.submit);
                                        }

                                        if (google.submit && google.submitAction) {
                                            sendGoogle(google.submit, google.submitAction);
                                        }

                                    }
                                } else {
                                    let successMessage = easyreviewsElement[i].querySelector('.js-easyreviews__success');

                                    successMessage.innerHTML('Ошибка отправки формы');
                                    successMessage.classList.add('is-visible');
                                    easyreviewsForm.classList.add('is-hidden');

                                    if (easyreviewsModal != null) {

                                        let easyreviewsTitle = easyreviewsModal.querySelector('.js-easyreviews-title');
                                        let easyreviewsDescription = easyreviewsModal.querySelector('.js-easyreviews-description');

                                    }

                                    if (yandex.counter && yandex.error) {
                                        sendYandex(yandex.counter, yandex.error);
                                    }

                                    if (google.error && google.errorAction) {
                                        sendGoogle(google.error, google.errorAction);
                                    }
                                }
                            }
                        }

                        xhr.open('POST', easyreviewsUrl);
                        xhr.send(formData);

                    } else {
                        if (yandex.counter && yandex.error) {
                            sendYandex(yandex.counter, yandex.error);
                        }

                        if (google.error && google.errorAction) {
                            sendGoogle(google.error, google.errorAction);
                        }
                    }

                });
            }

        };

        var initReviewRating = function initReviewRating() {
            const stars = document.querySelectorAll('.easyreviews__form-rating .easyreviews-rating-icon');

            stars.forEach(function (star) {
                star.addEventListener('click', function () {
                    const rating = star.getAttribute('data-value');

                    if (rating && rating > 0) {
                        stars.forEach(function (elm) {
                            elm.classList.remove('js-selected');
                        });

                        star.classList.add('js-selected');
                        const parent = star.closest('.easyreviews__form-rating');
                        parent.querySelector('.js-easyreviews__rating').setAttribute('value', rating);
                    }
                });
            });
        }

        var initModal = function initModal() {
            if (document.querySelectorAll('.easyreviews-modal').length) {

                let link = document.querySelectorAll('a[href="#easyreviews-modal"]');
                let button = document.querySelectorAll('.easyreviews-modal-toggler');

                for (let i = 0; i < link.length; i++) {
                    link[i].addEventListener('click', function () {
                        event.preventDefault();
                        MicroModal.show('easyreviews-modal');
                    });
                }

                for (let i = 0; i < button.length; i++) {
                    button[i].addEventListener('click', function () {
                        event.preventDefault();
                        MicroModal.show('easyreviews-modal');
                    });
                }


                MicroModal.init({
                    disableScroll: true,
                    onShow: function (modal) {
                        if (modal.classList.contains('easyreviews-modal')) {
                            let element = modal.querySelector('.js-easyreviews');

                            // yandexParams
                            let yandex = {
                                counter: element.getAttribute('data-counter'),
                                open: element.getAttribute('data-open'),
                            }

                            let google = {
                                open: element.getAttribute('data-gopen'),
                                openAction: element.getAttribute('data-gopenAction'),
                            }

                            if (yandex.counter && yandex.open) {
                                sendYandex(yandex.counter, yandex.open);
                            }

                            if (google.open && google.openAction) {
                                sendGoogle(google.open, google.openAction);
                            }
                        }
                    },
                    awaitCloseAnimation: true,
                });
            }
        }

        var initPhone = function initPhone(phone) {

            let mask = phone.getAttribute('data-mask');

            if (mask) {
                let phoneMask = new IMask(phone, {
                    mask: mask,
                    // lazy: false,
                    placeholderChar: '_',
                });
            }

        }

        var initInputFiles = function initInputFiles() {
            var inputs = document.querySelectorAll('.easyreviews__input--file');
            Array.prototype.forEach.call(inputs, function (input) {
                var label = input.nextElementSibling,
                    labelVal = label.innerHTML;

                input.addEventListener('change', function (e) {
                    var fileName = '';
                    if (this.files && this.files.length > 1) {
                        fileName = (this.getAttribute('data-multiple-caption') || '').replace('count', this.files.length);
                    } else {
                        fileName = e.target.value.split('\\').pop();
                    }

                    if (fileName) {
                        label.querySelector('span').innerHTML = fileName;
                    } else {
                        label.innerHTML = labelVal;
                    }
                });
            });
        }

        var sendYandex = function sendYandex(yandexId, target) {
            if (yandexId && target) {
                if (typeof window['yaCounter' + yandexId] !== 'undefined') {
                    var counter = window['yaCounter' + yandexId];
                    if (typeof counter !== 'undefined' && typeof counter.reachGoal !== 'undefined') {
                        counter.reachGoal(target);
                    }
                }
            }
        }

        var sendGoogle = function sendGoogle(category, action) {
            if (category && action) {
                if (typeof ga !== 'undefined') {
                    ga('send', 'event', category, action);
                }
            }
        }

        return {init: init};
    }();

    document.addEventListener('DOMContentLoaded', easyreviews.init);
}

// Easyreviews :: Lazyloading
var LazyLoading = (function ($) {

    var onScroll;

    LazyLoading = function (options) {
        var that = this;

        // VARS
        that.list_name = options['names']['list'];
        that.items_name = options['names']['items'];
        that.pagind_name = options['names']['paging'];
        that.load_class = 'is-loading';

        // DOM
        that.$wrapper = (options['$wrapper'] || false);
        that.$list = that.$wrapper.find(that.list_name);
        that.$window = $(window);

        // DYNAMIC VARS
        that.$paging = that.$wrapper.find(that.pagind_name);

        // INIT
        that.initLazyLoading();
    };

    LazyLoading.prototype.initLazyLoading = function () {
        var that = this;

        that.addWatcher();
    };

    LazyLoading.prototype.addWatcher = function () {
        var that = this;

        onScroll = function () {
            that.onScroll();
        };

        that.$window.on('scroll', onScroll);
    };

    LazyLoading.prototype.stopWatcher = function () {
        var that = this;

        if (typeof onScroll == 'function') {
            that.$window.off('scroll', onScroll);
        }
    };

    LazyLoading.prototype.onScroll = function () {
        var that = this,
            is_paging_exist = ($.contains(document, that.$paging[0]));

        if (is_paging_exist) {

            var $window = that.$window,
                scroll_top = $window.scrollTop(),
                display_height = $window.height(),
                paging_top = that.$paging.offset().top;

            // If we see paging, stop watcher and run load
            if (scroll_top + display_height >= paging_top) {
                that.stopWatcher();
                that.loadNextPage();
            }

        } else {
            that.stopWatcher();
        }
    };

    LazyLoading.prototype.loadNextPage = function () {
        var that = this,
            next_page_url = getNextUrl(),
            $paging = that.$paging;

        function getNextUrl() {
            var $nextPage = that.$paging.find('.selected').next(),
                result = false;

            if ($nextPage.length) {
                result = $nextPage.find('a').attr('href');
            }

            return result;
        }

        function showLoad() {
            var $loading = '<div class="loader"></div>';

            $paging
                .addClass(that.load_class)
                .prepend($loading);
        }

        if (next_page_url) {

            showLoad();

            $.get(next_page_url, function (response) {
                var $category = $(response),
                    $newItems = $category.find(that.list_name + ' ' + that.items_name),
                    $newPaging = $category.find(that.pagind_name);

                that.$list.append($newItems);

                $paging.after($newPaging);

                $paging.remove();

                that.$paging = $newPaging;

                that.addWatcher();
            });
        }
    };

    return LazyLoading;

})(jQuery);

var initLazyLoading = $('#js-easyreviews').find('.paging').hasClass('is-lazy-loading') ? true : false;
if (initLazyLoading) {
    new LazyLoading({
        $wrapper: $('#js-easyreviews'),
        names: {
            list: '.js-easyreviews-records__list',
            items: '.js-easyreviews-records__item--main',
            paging: '.js-easyreviews-paging'
        }
    });
}
